import React, { useState } from 'react';
import './App.scss';
import Landing from './components/Landing';
import SearchPage from './components/searchPage/search/SearchPage';

function App() {
  const [searchPage, setSearchPage] = useState(false);

  return (
    <div className="App">
      {searchPage ? (
        <SearchPage />
      ) : (
        <>
          <Landing setSearchPage={setSearchPage} />
          <div className="modal-overlay"></div>
        </>
      )}
    </div>
  );
}

export default App;
